import { ZenputFile, ZenputFiles } from '../../../shared/models/files';
import { MobileBaseModal } from '../../../shared/views/baseLayoutViews';
import { BaseFieldView } from '../BaseField/views';
import { createUUID } from '../../../../backbone-unorganized/utils/files';

export const SignatureModal = MobileBaseModal.extend({
    template: '#tpl_signature_dialog',
    id: 'signature_base',
    className: 'signature_display',

    form_collection: null,
    $signature_field: null, // the DOM element that jSignature is bound to
    _original_file: null, // lets us revert signature file if user cancels

    onRender: function () {
        this.$signature_field = this.$el.find('.signature_field');
    },

    onShow: function () {
        this.on_orientation_change();
    },

    events: {
        'click .signature_submit': 'submit_signature',
        'click .signature_clear': 'clear_signature',
        'click .signature_close': 'cancel'
    },

    initialize: function (options) {
        SignatureModal.__super__.initialize.apply(this, arguments);

        // save our file for later if we have one so we can restore it if the user cancels
        // (we can't use model.store()/restore() because that doesn't keep the file base64)
        if (this.model.get('file') && this.model.get('file').at(0)) {
            this._original_file = this.model.get('file').at(0);
        }
    },

    submit_signature: function (event) {
        var datapair = this._get_signature_data();

        if (!datapair) {
            this.close();
            return false;
        }

        var raw_file = {
            // This needs to be unique because our pending uploads ($f.mobile.uploads._pending_uploads) uses the
            // filename as its key. @jira:REPT-482
            name: `signature-${this.model.get('id')}-${new Date().getTime()}`,
            raw: datapair[1]
        };

        var mimetype = datapair[0];

        var file = new ZenputFile({
            id: createUUID(),
            mimetype: mimetype,
            raw_file: raw_file,
            url_base64: `data:${mimetype},${raw_file.raw}`
        });

        if (!raw_file.raw || raw_file.name == raw_file.raw) {
            $f.mobile.logging.log_error('Saving signature: file.raw not set properly.', {
                'file.raw': raw_file.raw
            });
        }

        this.model.set('file', new ZenputFiles([file]));

        this.close();
        return false;
    },

    on_orientation_change: function () {
        if (this.$signature_field.find('canvas')) {
            this.$signature_field.jSignature('destroy');
        }
        this.$signature_field.jSignature({
            sizeRatio: 3,
            height: '100%',
            width: '100%'
        });
    },

    clear_signature: function () {
        this.$signature_field.jSignature('reset');
        this.model.set({
            value: '',
            file: null
        });

        return false;
    },

    _get_signature_data: function () {
        if (!this.$signature_field) {
            return null;
        }

        // check for data using the 'native' type
        if (!this.$signature_field.jSignature('getData', 'native').length) {
            return null;
        }

        var data = this.$signature_field.jSignature('getData', 'image');

        if (!data.length) {
            return null;
        }

        return data;
    },

    remove: function () {
        SignatureModal.__super__.remove.call(this);
    },

    cancel: function (event) {
        // We prevent the default behavior in order to keep the anchor click from
        // taking the user to the href specified by the template.
        event && event.preventDefault();

        if (this._original_file) {
            this.model.set('file', [this._original_file]);
        }

        this.close();
    },

    close: function () {
        SignatureModal.__super__.close.call(this);
        this.on_close();
    }
});

export const SignatureFieldView = BaseFieldView.extend({
    events: {
        'click .add_signature_btn': 'show_signature'
    },

    /**
     * Find and format the src for the signature preview
     *
     * Attempt to return files first.
     *      Example is a saved draft would have a value, but after selecting a new file, also the file attribute, we want
     *      the new file attribute, not the old model value.
     *
     */
    templateHelpers: function () {
        var helpers = SignatureFieldView.__super__.templateHelpers.apply(this, arguments);
        var value = this.model.get('value');
        var files = this.model.get('file') || [];
        var src = '';

        if (files.length > 0) {
            src = files.at(0).get('url_base64');
        } else if (value) {
            // prior submissions have this as an element in an array.
            if (value instanceof Array && value.length) {
                value = value[0];
            }
            src = $f.storage.get_storage_full_url(value);
        }
        return $.extend(helpers, { src: src });
    },

    show_signature: function (event) {
        var this_ = this;
        $f.mobile.nav.show_modal(SignatureModal, {
            form_collection: this.form_collection,
            model: this.model,
            on_close: function () {
                $f.application.vent.trigger('mobile_form:scroll_to_element', { element: this_.$el });
            }
        });
        return false;
    }
});
